import React, { Component } from 'react'
import styled from 'styled-components'
import { withTranslation } from 'react-i18next'
import ReactDOM from 'react-dom';
import { renderSafeHtml } from '../../../utils/jsUtils';

import ChevronDown from '../../../images/chevron_green.svg'
import ChevronUp from '../../../images/chevron_green_up.svg'

const FAQContainer = styled.dl`
    margin: 0;
    padding: 0;
    background: white;

    > div {
        border-top: 1px solid  #DDDDDD;
        padding: 15px 10px 0 10px;

        > dt {
            > button {
                background-color: white;
                background-image: url(${ChevronDown});
                background-repeat: no-repeat;
                background-position: 100% center;

                padding: 0 5px;
                border: 0;
                font-family: Lato-Light;
                font-size: 18px;
                color: #4D4D4D;
                line-height: 22px;
                text-align: left;
                width: 100%;
                cursor: pointer;

                padding-right: 24px;
            }

            > button[aria-expanded=true] {
                background-image: url(${ChevronUp});
            }

            padding-bottom: 16px;
        }

        > dd {
            margin: 0;

            > p {
                border-top: 1px solid  #DDDDDD;
                margin: 0px 5px;
                padding: 9px 0px;
                display: inline-block;
                font-family: Lato-Regular;
                font-size: 14px;
                color: #2B2B2B;
                line-height: 22px;
        
                @media (max-width: 768px) {
                    margin-bottom: 6px;
                }
        
            }
        }
    } 
`

class Faq extends Component {

    componentDidMount() {
        const domNode = ReactDOM.findDOMNode(this);
        var buttons = domNode.querySelectorAll('button[aria-expanded][aria-controls]');
        for (var i = 0; i < buttons.length; i++) {
            var be = new window.ButtonExpand(buttons[i]);
            be.init();
        }
    }
    
    render() { 
        return (  
            <FAQContainer className="faq-container">
                {this.props.faqs.map(function(el, index){
                    return(
                        <div key={index}>
                            <dt>
                                <button tabIndex={0} aria-expanded="false" aria-controls={`faq_${index}`} className="faq-expander">
                                {el.question}
                                </button>
                            </dt>
                            <dd>
                                <div id={`faq_${index}`} className='faq-answer'>{renderSafeHtml(el.answer)}</div>
                            </dd>
                        </div>
                    )
                })}
            </FAQContainer>
        )
    }
}
 
export default withTranslation('translations')(Faq)
